/**
 * Associated entity type.
 * Do not change its values. Alternative is EntityType (for styles, etc)
 */
export enum WorkItemType {
  /**
   * Data collection.
   */
  Collection = 'Collection',
  /**
   * Data upload.
   */
  Upload = 'Upload',
  /**
   * Data utilization request.
   */
  Request = 'Request',
  /**
   * Virtual environment request.
   */
  VirtualEnvironment = 'VirtualEnvironment'
}

/**
 * Model for home page (WorkItemsComponent).
 */
export class WorkItem {
  /**
   * Entity display ID.
   */
  displayId: string;
  /**
   * WorkItem name.
   */
  name: string;
  /**
   * WorkItem status.
   */
  status: string;
  /**
   * Last modification date and time.
   */
  lastModifiedTime: Date;

  /**
   * Associated entity type.
   *
   * Required for navigation.
   */
  type: WorkItemType;
  /**
   * Associated entity ID.
   *
   * Required for navigation.
   */
  entityId: string;
  /**
   * Associated entity creator ID (DC and DUR only).
   *
   * Required for navigation.
   */
  creatorId: string;
  /**
   * Associated entity active version (DUR only).
   *
   * Required for navigation.
   */
  version: number;
  /**
   * Data collection ID associated with the entity (DU only).
   *
   * Required for navigation.
   */
  collectionId: string;
}

/**
 * Simple entity history model.
 */
export class WorkItemHistory {
  /**
   * Entity status change date.
   */
  changeTime: Date;
  /**
   * Entity new status.
   */
  newState: string;
  /**
   * Entity version.
   */
  version: number;
  /**
   * Entity display ID.
   */
  entityDisplayId: string;
}
